import { Tooltip } from 'antd';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const AiAnalyticsLabel = ({
  text = 'AI',
  description,
  placement,
  trigger = 'hover',
  size = '',
  hideTooltip = false,
}) => {
  const label = (
    <>
      <CroplerIcon name="ai" />
      {text}
    </>
  );

  return hideTooltip ? (
    <div className={`${styles.aiAnalyticsLabel} ${size === 'small' ? styles.aiAnalyticsLabelSmall : ''}`}>{label}</div>
  ) : (
    <Tooltip title={description} placement={placement} trigger={trigger}>
      <span className={`${styles.aiAnalyticsLabel} ${size === 'small' ? styles.aiAnalyticsLabelSmall : ''}`}>
        {label}
        <div className={styles.aiAnalyticsLabelInfo}>
          <CroplerIcon name="info" />
        </div>
      </span>
    </Tooltip>
  );
};

export default AiAnalyticsLabel;
